import { render, staticRenderFns } from "./wxGame.vue?vue&type=template&id=b95b3ce2"
import script from "./wxGame.vue?vue&type=script&lang=js"
export * from "./wxGame.vue?vue&type=script&lang=js"
import style0 from "./wxGame.vue?vue&type=style&index=0&id=b95b3ce2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports